import { styled, alpha } from '@mui/material/styles'
import Checkbox from '@mui/material/Checkbox'
import MenuItem from '@mui/material/MenuItem'

export const CustomMenuItem = styled(MenuItem)(() => ({
  '&.Mui-selected': {
    backgroundColor: 'transparent'
  }
}))

export const CustomCheckbox = styled(Checkbox)(({ theme }) => ({
  '&.Mui-checked': {
    backgroundColor: alpha(theme.palette.primary.main, 0.08),
  }
}))
